export default __webpack_public_path__ + "static/instagram-circle-245bb2e285e7ec9dabe1dc1478aebc90.png";